module.exports = __webpack_public_path__ + "img/logo_invert.59b5acad.png";